export default {
	computed: {
		messageStatus() {
			if (this.list.untouched) {
				return '';
			} else if (this.list.loading) {
				return 'Henter...';
			}
			return `Din søgning gav <strong>${this.list.results.pagination.total} resultater</strong>`;
		},
		messageNext() {
			if (this.list.preferences.pagination) {
				return 'Næste side';
			}
			return `Indlæs flere (af i alt ${this.list.results.pagination.total})`;
		},
		messagePrevious() {
			if (this.list.preferences.pagination) {
				return 'Forrige side';
			}
			return false;
		},
	},
	methods: {
		update() {
			this.list.update();
		},
		reset() {
			this.list.reset();
		},
		previous() {
			this.list.previous();
		},
		next() {
			this.list.next();
		},
	},
};



// WEBPACK FOOTER //
// ./scripts/sky-search/sky-search.mixin.js